module.exports = __webpack_public_path__ + "static/media/mode-30.636b02e6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-30.svg
// module id = 1003
// module chunks = 2